import { useEffect, useState } from 'react';
import { useGetWSTokenQuery } from '@/store/query/notification';
import { pushNotitication } from '@/store/notification/';
import { useDispatch } from 'react-redux';
import useNavigatorOnline from 'use-navigator-online';

export const useNotificationWorker = () => {
  const dispatch = useDispatch();
  const { backOnline } = useNavigatorOnline();

  const [tokenRequired, setTokenRequired] = useState(false);

  const { data } = useGetWSTokenQuery({}, { skip: !tokenRequired });
  const [worker, setWorker] = useState(null);

  useEffect(() => {
    // Note - Disable SharedWorker initialization if browser doesn't support.
    if (typeof SharedWorker !== 'function') return;

    const worker = new SharedWorker(new URL('./worker', import.meta.url), {
      name: 'kula-ws',
    });

    worker.port.onmessage = ({ data } = {}) => {
      const { type, payload } = data;
      if (type === 'WS-STATE' && !payload?.wsConnected) {
        setTokenRequired(true);
      }
    };

    window.onbeforeunload = function () {
      worker.port.close();
    };

    const broadcastChannel = new BroadcastChannel('kula-ws-channel');
    broadcastChannel.addEventListener('message', ({ data } = {}) => {
      const { type, payload } = data;
      switch (type) {
        case 'WS-STATE':
          console.log('WS Connected!', payload.state);
          break;
        case 'NOTIFICATION':
          dispatch(pushNotitication(payload));
          break;
        default:
      }
    });

    setWorker(worker);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!worker || !tokenRequired || !data?.token) return;
    setTokenRequired(false);
    worker.port.postMessage({
      type: 'INITIATE-WS',
      payload: { token: data?.token },
    });
  }, [worker, tokenRequired, data]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!worker || !backOnline) return;
    setTokenRequired(true);
  }, [worker, backOnline]);
};
